import { GlobalResponseObject } from "@gtpl/shared-models/common-models";
import { ValueAdditionFourDto } from "./addition-type-four.dto";

export class AllvalueAdditionFourResponse extends GlobalResponseObject{

      data?: ValueAdditionFourDto[];
    /**
     * 
     * @param status 
     * @param intlCode 
     * @param internalMessage 
     * @param data 
     */
    constructor(status:boolean, intlCode:number, internalMessage:string, data?: ValueAdditionFourDto[]){
        super(status,intlCode,internalMessage);
        this.status = status;
        this.internalMessage = internalMessage;
        this.intlCode = intlCode;
        this.data = data;
    }

}